/*APP公用引入配置*/
const appConfig = {
  version: "1.0.0", // 版本号 2.0.0 code 对应 165(当前版本2.0.0)
  platform: "H5", // 当前app平台 android 安卓平台， ios 苹果平台，  H5 html5平台
  interface: 1, // 1正式接口 2本地开发 3.本地开发 4.测试接口 5.外网接口
  routerListen: true, // 是否开启路由监控
  openLog: false, // 是否开启调试
  production: false, // 是否为调试真机生产环境
  openShopModule: false, // 是否开启商城模块  
  //分享url正式
  shareUrl: "http://wap.fujinmeng.com/#/shareRegister",
  // H5payUrl: "http://klb.rssyjt.cn/fjlm/rest/h5pay/topay/",
  // H5payUrl: "http://klb.rssyjt.cn/fjlm2/rest/h5pay/topay/",
  H5payUrl: "http://www.fujinmeng.com/fjlm/rest/h5pay/topay/",
  H5inviteGoodsUrl: "http://www.fujinmeng.com/fjlm/rest/h5pay/appSharePay", // 微信导购入口
  // H5inviteWXPay: "http://www.fujinmeng.com/fjlm/rest/h5pay/weixin",        // 导购微信支付接口
  H5inviteWXPay: "http://192.168.1.108:9080/fjlm/rest/h5pay/weixin",        // 导购微信支付接口
  oldUrl:"http://klb.rssyjt.cn/fjlm/rest/h5pay/topay/",
  shareShopUrl: "http://wap.fujinmeng.com/#/shopDetial",
  shareGoosUrl:'http://wap.fujinmeng.com/#/physicalStore',
  // appLogo: require("../assets/img/logov1.png"),
  // appLogoTitle: require("../assets/img/logo-title.png"),
  // appGzhCode: "http://www.fujinmeng.com/fjlm/rest/files/fjlmgzh.png",
  cacheImgDir: "_downloads/image", // 可清除图片缓存路径
  // cacheImgDir: "_doc/image", // 可清除图片缓存路径
  unclearableCache: "_downloads/always_cache", // 不可清除的缓存，如头像等
  downLoadAppUrl:
    "https://android.myapp.com/myapp/detail.htm?apkName=fujinlianmen.hx.com&ADTAG=mobile", // app下载地址
  roleState:localStorage.getItem("role")==="录入人员"?false:true
};
if(appConfig.platform=='H5'){ // H5无真机测试环境
  appConfig.production = false;
}
export default appConfig;
